module.exports = "/_next/static/images/TestimonialImage@2x-d914aaedb85d9041abd5607829bd92cf.png";